module.exports = __webpack_public_path__ + "static/countdownboards-7f30bb137a21cceca2abff0972598c2d.jpeg";